import { Navigate, Outlet, Routes as ReactRoutes, Route } from "react-router-dom";
import pagesRoutes from "pages/routes";

import { RouteType } from "types/route";
import { AccountContext } from "services/account";
import React from "react";
import { LandingPage } from "./pages";
import Page from "components/Page";

const Routes = (): JSX.Element => {
	const account = React.useContext(AccountContext);
	const AuthRoute = ({ route, redirectPath = "/app/signin" }: { route: RouteType; redirectPath?: string }) => {
		if (!account.getToken()) {
			return (
				<Navigate
					to={redirectPath}
					replace
				/>
			);
		}
		return route.renderer();
	};
	const UnAuthRoute = ({ route, redirectPath = "/app/" }: { route: RouteType; redirectPath?: string }) => {
		if (account.getToken()) {
			return (
				<Navigate
					to={redirectPath}
					replace
				/>
			);
		}
		return route.renderer();
	};

	return (
		<ReactRoutes>
			<Route
				path="/"
				element={<LandingPage />}
			/>

			<Route
				path="/zh/"
				element={<LandingPage />}
			/>
			<Route path="app">
				<Route
					element={
						<Page>
							<Outlet />
						</Page>
					}>
					{pagesRoutes.map((route) => {
						switch (route.type) {
							case "auth":
								return (
									<Route
										key={route.path}
										index={route.path === ""}
										path={route.path}
										element={<AuthRoute route={route} />}
									/>
								);
							case "unauth":
								return (
									<Route
										key={route.path}
										index={route.path === ""}
										path={route.path}
										element={<UnAuthRoute route={route} />}
									/>
								);
							default:
								return (
									<Route
										key={route.path}
										index={route.path === ""}
										path={route.path}
										element={route.renderer()}
									/>
								);
						}
					})}
				</Route>
			</Route>
			<Route
				path="*"
				element={
					<Navigate
						replace
						to={`/`}
					/>
				}
			/>
		</ReactRoutes>
	);
};

export default Routes;
